module.exports = __webpack_public_path__ + "img/main_technic_1.a6c43a27.jpg";